import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from 'modules/app'
import { Provider } from 'react-redux'
import store from 'logic/store'
import reportWebVitals from './reportWebVitals'
// import 'core-js/es/object';
import 'core-js';


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
